import React, { useEffect, useState } from 'react';
import { isUserLogedIn } from '../../utilities/auth';
import { getSyncStatus } from '../../services/sync';
import TopNavAlertComponent from '../Alerts/topNavAlert';
import { TOP_ALERT_TYPES } from '../../constants/types';
import { getSyncTime } from '../../services/snapshot';

const SyncNotifications = ({ setNotificationClass }) => {
  const [isSnapshotOpen, setIsSnapshotOpen] = useState(false);
  const [firstSync, setFirstSync] = useState(false);
  const [syncRunning, setSyncRunning] = useState(false);
  const [hasAccount, setHasAccount] = useState(true);
  const [syncDisabled, setSyncDisabled] = useState(false);

  //@TODO: update later.
  // useEffect(() => {
  //   let sync_status = { first_sync: false, sync_running: false, has_account: true, sync_disabled: false };
  //   const interval = setInterval(() => {
  //     if (isUserLogedIn()) {
  //       sync_status = getSyncStatus().then((data) => {
  //         let default_sync_status = { first_sync: false, sync_running: false, has_account: true, sync_disabled: false };
  //         sync_status =
  //           data && data?.data?.data
  //             ? data?.data?.data
  //             : default_sync_status;

  //         default_sync_status = { ...default_sync_status, ...sync_status };

  //         setFirstSync(default_sync_status.first_sync);
  //         setSyncRunning(default_sync_status.sync_running);
  //         setHasAccount(default_sync_status.has_account);
  //         setSyncDisabled(default_sync_status.sync_disabled);
  //       });
  //     }
  //   }, 5000);
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    const data = getSyncTime();
    if (data) {
      setIsSnapshotOpen(true);
    } else {
      setIsSnapshotOpen(false);
    }
  });

  const getAlertInfo = () => {
    const alerts = [];

    if (!hasAccount) {
      alerts.push({
        type: TOP_ALERT_TYPES.ADDACCOUNT,
        variant: '',
        icon: 'adduser'
      })
    }

    if (isSnapshotOpen) {
      alerts.push({
        type: TOP_ALERT_TYPES.SNAPSHOT,
        variant: 'warning',
        icon: 'date_time'
      });
    }

    if (syncDisabled) {
      alerts.push({
        type: TOP_ALERT_TYPES.ACCOUNTSYNCOFF,
        variant: 'info',
        icon: ''
      })
    }

    if (firstSync && syncRunning) {
      alerts.push({
        type: TOP_ALERT_TYPES.FIRSTSYNC,
        variant: 'info',
        icon: ''
      })
    } else if (!firstSync && syncRunning) {
      alerts.push({
        type: TOP_ALERT_TYPES.SYNC,
        variant: 'info',
        icon: ''
      })
    }

    if (alerts.length > 1) {
      alerts.map((item) => (
        item.variant = 'offline'
      ))
    }

    return alerts;
  }

  // first_sync 
  // sync_running
  // has_account
  // open -> rename to is_snapshot
  // accountsyncoff varient: error which is red color

  // if there are more than one default color varient: offline

  // Set the margin top for the body if there is notification

  if (isSnapshotOpen || !hasAccount || (firstSync && syncRunning) || (!firstSync && syncRunning)) {
    setNotificationClass(`mt-${(getAlertInfo().length) * 35}`);
  } else {
    setNotificationClass('');
  }

  return (
    <TopNavAlertComponent
      alertInfo={getAlertInfo()}
    />
  )
};

export default SyncNotifications;
